import { Heading, HeadingSize } from 'components/Ui-Kits/Text'
import { useDateCountdown } from 'hooks/useDateCountdown'
import { useAppTranslation } from 'i18n/hooks'
import { instanceOf } from 'prop-types'
import styled from 'styled-components'

export const CountdownWrap = ({ startDate }) => {
  const { t } = useAppTranslation()
  const min = useDateCountdown(startDate)

  return (
    <MessageWrap>
      <Heading color="primary" size={HeadingSize.SMALLEST} mt={0} mb={0}>
        {t('LiveAuctionWillStartIn', { min })}
      </Heading>
    </MessageWrap>
  )
}

CountdownWrap.propTypes = {
  startDate: instanceOf(Date).isRequired,
}

const MessageWrap = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid var(--color-primary);
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;

  ${Heading} {
    text-align: center;
  }
`
